// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50b1c140","453":"31adf576","732":"e9332f1d","977":"b8f74c64"}[chunkId] + ".chunk.js";
};